const printPrettyPhoneNumber = number =>
  number?.replace(/(\d{3})(\d{3})(\d{4})/, ' ($1) $2-$3');

export default printPrettyPhoneNumber;
